/*
 * tk-lp.js — 旧 WordPress サイトの inline jQuery / js/common.js の UI 挙動を移植したもの
 *
 * 読込: layout/theme.liquid で jQuery → slick → lity → 本ファイル の順にすべて defer で読む (全テンプレ共通 1 本)。
 * 方針: 各処理は対象要素が存在するときだけ動く。イベントは document への名前空間付き委譲 (.tkLp) で 1 回だけ張る。
 *       グローバル変数は作らない (IIFE + jQuery(function($){}) 内で完結)。
 *
 * ── 移植対応表 (旧ページ / 旧ファイル → 対象セレクタ → 内容) ─────────────────────────────
 *  [1] mrc/index.html inline「$('.slide_inner1〜9').slick({...})」(9 ブロック)
 *      mouthpiece/index.html inline「$('.slide_inner1〜8').slick({...})」(8 ブロック)
 *        → [class*="slide_inner"] (症例 blocks 由来で件数可変のため総称で一括)
 *        → slick 初期化。オプションは全 17 ブロックで完全一致のため 1 回にまとめた (値は旧コードのまま)
 *  [2] mrc/index.html・mouthpiece/index.html inline「$('#tab-menu li').on('click', ...)」(同一コード)
 *        → #tab-menu li / #tab-box .tabinbox → .active 切替 + 表示タブ内 .slide > div へ slick('setPosition')
 *  [3] mrc/index.html inline「$('.inline').colorbox({inline:true, onComplete: #video.play()})」
 *        → a.inline[data-lity] (#movie_mob)。ライトボックス自体は lity の data-lity 自動バインドで代替済み。
 *          ここでは onComplete 相当 (表示完了で #video を再生) を lity:ready で再現
 *  [4] mrc/price.html inline「$('.img_box').colorbox({opacity:0.7})」
 *        → a.img_box[href] (控除の画像リンク) を lity で拡大表示 (colorbox はテーマ未導入のため lity で代替)
 *  [5] mrc/faq.html inline「URL の #ID の .faq_box を初期展開」
 *        → .faq_box (#q01_01 等)。h4 に .open + 次要素 (.open_box) を展開。
 *          ※ 同 inline のクリック開閉 (.faq_box h4 click) は assets/tk-drawer.js に vanilla 実装済みのため移植しない
 *  [6] mrc/index.html inline「$('.feature li').matchHeight(); $('.staff .prof_box > div').matchHeight();」
 *      mrc/faq.html inline「$('.link_box li').matchHeight();」
 *      index.html (トップ) inline「#anshin .point1 .point1_inbox .inbox2 dl dd / #anshin .point_list ul li .txt」
 *        → 各セレクタごとに高さ揃え。jquery.matchHeight はテーマ未導入のため、同プラグイン既定 (byRow:true,
 *          property:height, load/resize で再計算) 相当の最小実装を内蔵
 *  [7] index.html (トップ) inline「setHeight(): .m_img_area .slide の高さ = ウィンドウ高 − header 高」
 *        → .m_img_area .slide (ready + resize)。CSS の min/max-height はそのまま効く (旧サイトと同じ)
 *  [8] js/common.js・mrc/js/common.js・mouthpiece(petit)/js/common.js「ヘッダー分のズレ調整 (adjustSet/adjustReset)」
 *        → .ank_adjust に margin-top:-H / padding-top:H。H と無効条件は旧サイトの 3 系統どおり:
 *            トップ系 (header .h_box_r)      : header .h_box_r 非表示なら解除、H = #scl_header 高
 *            mouthpiece/petit (#header .m_nav_area): .m_nav_area 非表示なら解除、H = #scl_header 高
 *            mrc 系 (#header .nav_box)       : .nav_box 無し/非表示なら解除、H = #header .nav_box 高
 *  [9] 3 系統の common.js「ボックスリンク」.blocklink / .blocklink_out、js/common.js「.blocklink_ank」
 *        → ブロック全体クリックで中の最初の a の href へ遷移 / 別窓 / ページ内スムーススクロール (500ms swing)
 * [10] 3 系統の common.js「アルファ用」.hover, .hover_list li (+ mrc/js/common.js の .faq h4)
 *        → hover で opacity 0.7 / 1 を 600ms アニメーション
 * [11] 3 系統の common.js「ページトップ」#page_top → スクロール 500px 超で fadeIn、以下で fadeOut
 * [12] js/common.js (トップ系のみ)「スマホメニュー」#sp_footer → スクロール 100px 超で fadeIn
 *        → トップ系フッター (tk-footer セクション内の #sp_footer) のみ。LP (mrc/mouthpiece/petit) の common.js には無いので LP では常時表示のまま
 * [13] mrc/js/topslide.js (外部ファイル・inline ではないが mrc LP で未移植だったため同梱)
 *        → .loopslider[rel=loopleft|loopright] の無限横ループ (slideTime 100000ms linear)
 *
 * ── 意図的に移植しないもの ──────────────────────────────────────────────
 *  - トップ .m_slider の slick 初期化 → layout/theme.liquid に既存
 *  - $('.drawer').drawer() / iscroll → assets/tk-drawer.js (vanilla) で代替済み
 *  - common.js のスクロール固定ヘッダー (#scl_header.is-show)・a[href^="#"] スムーススクロール・#page_top クリック・
 *    m_nav アコーディオン (openSubMenuLong)・.faq_box h4 開閉 → assets/tk-drawer.js に実装済み (二重発火防止)
 *  - common.js のメインナビ .select 付与 → snippets/tk-m_nav.liquid で Liquid 付与済み
 *  - common.js の Retina srcset (img.retina → @2x) → テーマ assets に @2x 版がほぼ無く (338 枚中 3 枚)、付けると 404 になるため
 *  - common.js の .over ロールオーバー / span[data-action=call] / [data-sp-href] / footer .open_btn / .view_timer → 該当要素がテーマに無い
 *  - mouthpiece inline の #loop_slide slick・PerfectScrollbar(#scl1〜4) → 該当要素がテーマに無い (プラグインも未導入)
 *  - トップ inline の Instagram (#sbi_images) bxSlider → Instagram Feed プラグイン (WP) 依存でテーマに無い
 *  - GTM / Google Maps API / wpemoji / speculationrules / sbi 設定 / Typekit・CSS の動的 link 挿入 / 計測タグ
 *    (cmkt.jp・mieruca・Google リマーケティング・Yahoo リターゲティング) → UI 挙動ではないため対象外
 */
(function () {
  'use strict';

  if (typeof jQuery === 'undefined') return;

  jQuery(function ($) {
    var $doc = $(document);
    var $win = $(window);
    var $root = $(document.documentElement);

    // 二重読込ガード (グローバル変数を使わず documentElement の data に印を付ける)
    if ($root.data('tkLpInit')) return;
    $root.data('tkLpInit', true);

    /* ------------------------------------------------------------------
     * [1] 症例スライダー (.slide_inner{N}) — mrc / mouthpiece 旧 inline と同一オプション
     * ------------------------------------------------------------------ */
    var CASE_SLICK_OPTIONS = {
      dots: false,
      autoplay: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      arrows: true,
      autoplaySpeed: 8000,
      speed: 500
    };

    function initCaseSliders(context) {
      if (!$.fn.slick) return;
      $(context || document)
        .find('[class*="slide_inner"]')
        .not('.slick-initialized')
        .each(function () {
          $(this).slick(CASE_SLICK_OPTIONS);
        });
    }
    initCaseSliders();

    /* ------------------------------------------------------------------
     * [2] 症例タブ切替 (#tab-menu li → #tab-box .tabinbox) + slick setPosition
     * ------------------------------------------------------------------ */
    $doc.on('click.tkLp', '#tab-menu li', function () {
      var $li = $(this);
      // タブメニュー
      $li.addClass('active').siblings('li').removeClass('active');
      // タブの中身
      var index = $('#tab-menu li').index(this);
      var $box = $('#tab-box .tabinbox').eq(index);
      $box.addClass('active').siblings('.tabinbox').removeClass('active');
      // 非表示中に初期化された slick の幅を再計算 (旧コードの「追加」部分)
      if ($.fn.slick) {
        $box.find('.slide > div').filter('.slick-initialized').slick('setPosition');
      }
    });

    /* ------------------------------------------------------------------
     * [3] 動画ライトボックス: 表示完了で #video を再生 (旧 colorbox onComplete 相当)
     *     lity は inline 要素を閉じたあと元位置 (.dsp_n 内) へ戻すため、閉じたら停止して裏で鳴り続けないようにする
     * ------------------------------------------------------------------ */
    $doc.on('lity:ready.tkLp', function (e) {
      var $content = $(e.target);
      var video = $content.is('#video') ? $content.get(0) : $content.find('#video').get(0);
      if (video && typeof video.play === 'function') {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    });
    $doc.on('lity:close.tkLp', function (e, instance) {
      var $el = instance && typeof instance.element === 'function' ? instance.element() : $(e.target);
      $el.find('video').each(function () {
        if (typeof this.pause === 'function') this.pause();
      });
    });

    /* ------------------------------------------------------------------
     * [4] mrc/price: a.img_box を拡大表示 (旧 colorbox → lity)
     *     data-lity 付きは lity 自身がバインド済みなので除外
     * ------------------------------------------------------------------ */
    $doc.on('click.tkLp', 'a.img_box[href]:not([data-lity])', function (e) {
      if (typeof window.lity !== 'function') return;
      var href = $(this).attr('href');
      if (!href) return;
      e.preventDefault();
      window.lity(href);
    });

    /* ------------------------------------------------------------------
     * [5] mrc/faq: URL の #ID が .faq_box ならその Q&A を初期展開
     *     (開閉状態は tk-drawer.js と同じ「h4.open + .open_box 表示」で揃える)
     * ------------------------------------------------------------------ */
    (function openFaqFromHash() {
      var hash = window.location.hash;
      if (!hash || hash.length < 2) return;
      var firstQA = document.getElementById(hash.substring(1));
      if (!firstQA) return;
      var $h4 = $(firstQA).children('h4');
      if (!$h4.length) return;
      $h4.next().slideToggle();
      $h4.addClass('open');
    })();

    /* ------------------------------------------------------------------
     * [6] 高さ揃え (jquery.matchHeight 既定動作の最小実装: byRow / height)
     * ------------------------------------------------------------------ */
    var MATCH_GROUPS = [
      '.feature li',                                   // mrc
      '.staff .prof_box > div',                        // mrc
      '.link_box li',                                  // mrc/faq
      '#anshin .point1 .point1_inbox .inbox2 dl dd',   // トップ
      '#anshin .point_list ul li .txt'                 // トップ
    ];

    function verticalExtra($el) {
      if ($el.css('box-sizing') === 'border-box') return 0;
      var sum = 0;
      ['border-top-width', 'border-bottom-width', 'padding-top', 'padding-bottom'].forEach(function (p) {
        sum += parseFloat($el.css(p)) || 0;
      });
      return sum;
    }

    function matchGroup(selector) {
      var $items = $(selector);
      if ($items.length < 2) return;
      $items.css('height', '');
      // 行ごとにグループ化 (top 位置の差が 1px 以内を同じ行とみなす)
      var rows = [];
      var lastTop = null;
      $items.filter(':visible').each(function () {
        var $el = $(this);
        var top = $el.offset().top - (parseFloat($el.css('margin-top')) || 0);
        if (lastTop === null || Math.floor(Math.abs(lastTop - top)) > 1) {
          rows.push($());
        }
        rows[rows.length - 1] = rows[rows.length - 1].add($el);
        lastTop = top;
      });
      rows.forEach(function ($row) {
        if ($row.length < 2) return;
        var max = 0;
        $row.each(function () {
          max = Math.max(max, $(this).outerHeight(false));
        });
        $row.each(function () {
          var $el = $(this);
          $el.css('height', (max - verticalExtra($el)) + 'px');
        });
      });
    }

    var activeMatchGroups = MATCH_GROUPS.filter(function (sel) {
      return $(sel).length > 1;
    });
    function matchAll() {
      activeMatchGroups.forEach(matchGroup);
    }

    /* ------------------------------------------------------------------
     * [7] トップ: メインビジュアル .m_img_area .slide = ウィンドウ高 − header 高
     * ------------------------------------------------------------------ */
    var $mvSlides = $('.m_img_area .slide');
    function setHeight() {
      var winH = $win.height();
      var headH = $('header').outerHeight() || 0;
      $mvSlides.height(winH - headH);
    }

    /* ------------------------------------------------------------------
     * [8] .ank_adjust のヘッダー分ズレ調整 (旧 common.js 3 系統)
     * ------------------------------------------------------------------ */
    var $ank = $('.ank_adjust');
    var ankMode = null;
    if ($ank.length) {
      if ($('#header .nav_box').length) {
        ankMode = 'mrc';
      } else if ($('#header .m_nav_area').length) {
        ankMode = 'mouthpiece';
      } else if ($('header .h_box_r').length) {
        ankMode = 'top';
      }
    }
    function ankTrigger() {
      if (ankMode === 'mrc') return $('#header .nav_box');
      if (ankMode === 'mouthpiece') return $('#header .m_nav_area');
      return $('header .h_box_r');
    }
    function ankHidden() {
      var $t = ankTrigger();
      return !$t.length || $t.css('display') === 'none';
    }
    function adjustReset() {
      $ank.css({ 'margin-top': '0', 'padding-top': '0' });
    }
    function adjustSet() {
      var h = ankMode === 'mrc' ? $('#header .nav_box').outerHeight() : $('#scl_header').outerHeight();
      h = h || 0;
      $ank.css({ 'margin-top': '-' + h + 'px', 'padding-top': h + 'px' });
    }
    function adjustInit() {
      if (!ankMode) return;
      if (ankHidden()) {
        adjustReset();
      } else {
        adjustSet();
      }
    }
    adjustInit();

    /* ------------------------------------------------------------------
     * [9] ボックスリンク
     *     中の a 自体のクリックは a の既定動作 / tk-drawer.js のスムーススクロールに任せる
     *     (旧サイトは a 側ハンドラの return false で伝播が止まっていたため同じ結果になる)
     * ------------------------------------------------------------------ */
    function firstHref($block) {
      return $block.find('a').first().attr('href');
    }
    function clickedInsideLink(e, block) {
      var $a = $(e.target).closest('a');
      return $a.length && $.contains(block, $a.get(0));
    }

    $doc.on('click.tkLp', '.blocklink', function (e) {
      if (e.isDefaultPrevented() || clickedInsideLink(e, this)) return;
      var href = firstHref($(this));
      if (!href) return;
      e.preventDefault();
      window.location = href;
    });

    // 別窓 (旧コードどおり中の a のクリックも含めて window.open)
    $doc.on('click.tkLp', '.blocklink_out', function (e) {
      if (e.isDefaultPrevented()) return;
      var href = firstHref($(this));
      if (!href) return;
      e.preventDefault();
      window.open(href, '_blank');
    });

    // ブロックリンク + ページ内スムーススクロール
    // テーマでは href が「/pages/xxx#id」形式のため、同一ページの場合のみ #id へスクロール (別ページなら通常遷移)
    $doc.on('click.tkLp', '.blocklink_ank', function (e) {
      if (e.isDefaultPrevented()) return;
      var href = firstHref($(this));
      if (!href) return;
      var a = document.createElement('a');
      a.href = href;
      var samePage = a.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
      var $target = $();
      if (samePage) {
        $target = a.hash && a.hash.length > 1 ? $(document.getElementById(a.hash.substring(1))) : $('html');
      }
      e.preventDefault();
      if (!$target.length) {
        window.location = href;
        return;
      }
      $('html, body').animate({ scrollTop: $target.offset().top }, 500, 'swing');
    });

    /* ------------------------------------------------------------------
     * [10] アルファ用 hover
     * ------------------------------------------------------------------ */
    var HOVER_SEL = '.hover, .hover_list li, .faq h4';
    $doc.on('mouseenter.tkLp', HOVER_SEL, function () {
      $(this).stop().animate({ opacity: '0.7' }, 600);
    });
    $doc.on('mouseleave.tkLp', HOVER_SEL, function () {
      $(this).stop().animate({ opacity: '1' }, 600);
    });

    /* ------------------------------------------------------------------
     * [11] #page_top / [12] トップ系 #sp_footer のスクロール表示
     * ------------------------------------------------------------------ */
    var $pageTop = $('#page_top');
    var $spFooter = $('#shopify-section-tk-footer #sp_footer');
    $pageTop.hide();
    $spFooter.hide();

    function onScrollToggle() {
      var y = $win.scrollTop();
      if ($pageTop.length) {
        if (y > 500) { $pageTop.fadeIn(); } else { $pageTop.fadeOut(); }
      }
      if ($spFooter.length) {
        if (y > 100) { $spFooter.fadeIn(); } else { $spFooter.fadeOut(); }
      }
    }
    if ($pageTop.length || $spFooter.length) {
      $win.on('scroll.tkLp', onScrollToggle);
      onScrollToggle();
    }

    /* ------------------------------------------------------------------
     * [13] mrc: .loopslider の無限横ループ (旧 mrc/js/topslide.js)
     * ------------------------------------------------------------------ */
    $('.loopslider').each(function () {
      var slideTime = 100000;
      var targetObj = $(this);
      if (targetObj.children('.loopslider_wrap').length) return;
      var classFilter = targetObj.attr('rel'); // 'loopleft' or 'loopright'
      var loopsliderHeight = targetObj.height();
      targetObj.children('ul').wrapAll('<div class="loopslider_wrap"></div>');
      var findWrap = targetObj.find('.loopslider_wrap');
      var listWidth = findWrap.children('ul').children('li').width();
      var listCount = findWrap.children('ul').children('li').length;
      var loopWidth = listWidth * listCount;

      findWrap.css({
        top: '0',
        left: '0',
        width: loopWidth * 2,
        height: loopsliderHeight,
        overflow: 'hidden',
        position: 'absolute'
      });
      findWrap.children('ul').css({ width: loopWidth });

      function loopPosLeft() {
        findWrap.css({ left: '0' });
        findWrap.stop().animate({ left: '-' + loopWidth + 'px' }, slideTime, 'linear');
        setTimeout(loopPosLeft, slideTime);
      }
      function loopPosRight() {
        var wrapWidth = findWrap.width();
        findWrap.css({ left: '-' + wrapWidth / 2 + 'px' });
        findWrap.stop().animate({ left: '0' }, slideTime, 'linear');
        setTimeout(loopPosRight, slideTime);
      }

      if (classFilter === 'loopleft') {
        loopPosLeft();
        findWrap.children('ul').clone().appendTo(findWrap);
      }
      if (classFilter === 'loopright') {
        loopPosRight();
        findWrap.children('ul').clone().prependTo(findWrap);
      }
    });

    /* ------------------------------------------------------------------
     * 共通: ready / load / resize
     * ------------------------------------------------------------------ */
    if ($mvSlides.length) setHeight();
    matchAll();

    $win.on('load.tkLp', function () {
      matchAll();
      if (ankMode && !ankHidden()) adjustSet();
    });

    var resizeTimer = null;
    $win.on('resize.tkLp', function () {
      if ($mvSlides.length) setHeight();
      if (ankMode && ankHidden()) adjustReset();
      if (resizeTimer !== null) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resizeTimer = null;
        matchAll();
        if (ankMode && !ankHidden()) adjustSet();
      }, 200);
    });

    /* ------------------------------------------------------------------
     * テーマエディタ: セクション再読込時に新しい DOM の slick だけ初期化 (イベントは委譲なので再バインド不要)
     * ------------------------------------------------------------------ */
    $doc.on('shopify:section:load.tkLp', function (e) {
      initCaseSliders(e.target);
    });
  });
})();
